export default {
  status: 0,
  data: {
    TBBA001: {
      CP_CD: '0801',
      CP_NM: 'KIOSK-FOODKIOSK-FOOD',
      CP_SHORT_NM: 'KIOSK-FOOD',
      CP_EN_NM: '',
      CP_EN_SHORT_NM: '',
      BZ_NO: '0000000000',
      CORP_REG_NO: '',
      UPTAE_FLG_CD: '98',
      BOSS_NM: '',
      REP_TEL_NO: '',
      REP_FAX_NO: '',
      HMPG_ADDR: '',
      REP_EMAIL_ADDR: '',
      CNTRY_CD: '',
      ZIPNO: '',
      BASE_ADDR: '',
      DTL_ADDR: '',
      BASE_ADDR_EN: '',
      DTL_ADDR_EN: '',
      BANK_CD: '',
      BANK_ACC_NO: '',
      DPSTOR_NM: '',
      CI_FILE_ID: '',
      CP_PATH: 'Standard',
      CP_PORT: '8186',
      DEL_YN: 'N',
      REG_DTMS: '2023-10-20 11:25:30',
      REGER_ID: '',
      REG_IP: '',
      UPDT_DTMS: '2023-10-20 11:25:30',
      UPDTER_ID: '',
      UPDT_IP: '',
      DECIMAL_PLC: 0,
      AMT_UNIT: '1',
      SALE_UNIT: '1',
      AMT_CMPT_TYPE: '1',
      TAX_CMPT_TYPE: '1',
      TAX_RATE: 10,
      TAX_RDC_RATE: 0,
      CURR_UNIT: '001',
      TIME_ZONE: '230',
      CP_GLOBAL: 'Y',
      MST_USE_YN: 'Y',
      ERP_SEND_FLG: 'N',
      BO_URL: 'https://cloudposofficedevo.shinsegae.com',
      POS_MAIN_URL_CD: '001',
      POS_SUB_URL_CD: '001',
      POS_TRAIN_URL_CD: '001',
      VER_NO: '2',
      CLAS_LEVEL: '3',
      VAT_CMPT_TYPE: '2',
      NON_PLU_PREFIX: '20',
      NON_PLU_TYPE_CD: 'I04W0P6C1',
    },
    TBBA003: {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0002',
      SHOP_ID: '0003626',
      TNANT_NM: 'ShinSeGaeI&C',
      TNANT_SHORT_NM: 'ShinSeGaeI&C',
      TNANT_EN_NM: '',
      TNANT_EN_SHORT_NM: '',
      BZ_NO: '0000000000',
      STORE_OWN_NM: 'TEST',
      TEL_NO: '01000000000',
      FAX_NO: '',
      EMAIL_ADDR: '',
      ZIPNO: '04529',
      BASE_ADDR: '서울특별시 중구 회현동1가 204 (MESA)',
      DTL_ADDR: 'MESA',
      BASE_ADDR_EN: '',
      DTL_ADDR_EN: '',
      FLOOR_FLG_CD: '0001',
      CONT_AREA: 10,
      DVT_AREA: 30,
      TNANT_AREA: 20,
      OPEN_YN: 'Y',
      OPEN_DATE: '20230419',
      CLSP_YN: 'N',
      CLSP_DATE: '',
      BANK_CD: '001',
      BANK_ACC_NO: '4472E8AA281B2DB71D1B14876E7C5284',
      DPSTOR_NM: '0E6F406B28900A6EC29C5BBA947295BB',
      PARKING_CD: '000',
      STMP_PRT_FLG_CD: 'X',
      STMP_FILE_ID: '',
      STMP_FILE_URL: '',
      CI_PRT_YN: 'N',
      DEL_YN: 'N',
      REG_DTMS: '2023-10-20 11:25:31',
      REGER_ID: '',
      REG_IP: '',
      UPDT_DTMS: '2023-10-20 11:25:31',
      UPDTER_ID: '',
      UPDT_IP: '',
      STK_MV_USE_YN: 'N',
      STK_MV_BAS_FLG: '0',
      STK_MV_DIT_GRP: '',
      STK_MV_DIT_PRICE: 0,
      TNANT_TYPE: '01',
      APPR_FLG: '02',
      SALE_FLG: '01',
      CHANNEL_FLG: '01',
      MST_USE_YN: null,
      ERP_TNANT_CD: null,
      AREA: null,
      FOODTECH_CODE: null,
      SOHO_BRAND_FLG_CD: null,
      CLAS_LEVEL: null,
      NON_PLU_PREFIX: '20',
      NON_PLU_TYPE_CD: 'I04W0P6C1',
      DECIMAL_PLC: 0,
      AMT_UNIT: '1',
      SALE_UNIT: '2',
      AMT_CMPT_TYPE: '2',
      TAX_CMPT_TYPE: '1',
      DC_SALE_UNIT: '2',
      DC_COMP_TYPE: '',
      DC_TARGET_AMT_TYPE: '1',
      TAX_RATE: 10,
      TAX_RDC_RATE: 0,
      LANG_FLG: 'KO',
      DC_CMPT_TYPE: '2',
      VAT_CMPT_TYPE: '1',
    },
    TBBA008: {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0002',
      POS_NO: '0001',
      POS_NM: 'POS1',
      POS_EN_NM: '',
      FRONT_SYS_FLG_CD: '01',
      POS_TMNL_FLG_CD: '4',
      TEL_NO: '',
      IP: '',
      FLOOR_FLG_CD: '0000',
      INSTALL_LOC: '',
      DEVICE_SERIAL_NO: '',
      USE_FROM_DATE: '20230419',
      USE_END_DATE: '29991231',
      DISTOR_MODEL_NO: '',
      DISTOR_USE_CNT: 0,
      USE_YN: 'Y',
      DEL_YN: 'N',
      REG_DTMS: '2023-10-20 11:25:31',
      REGER_ID: '',
      REG_IP: '',
      UPDT_DTMS: '2023-10-20 11:25:31',
      UPDTER_ID: '',
      UPDT_IP: '',
      SETUP_STATUS_CD: '2',
      ETC_TYPE_CD: '',
    },
    TB_MST_TNANT_PRINTOUT: [
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0002',
        SHOP_ID: '0003626',
        PRINTOUT_FLG_CD: '01',
        PRINTOUT_FORM:
          '{NADD}{CENTER}{진동벨번호1}\n\n{NADD}{상단메시지}\n\n점  포  명:{매장명}\n대  표  자:{매장대표자명}\n사업자번호:{매장사업자번호}\n전 화 번호:{매장전화번호}\n{주소1}\n{주소2}\n\n{판매일자} {판매시간}\n거래번호:{POS번호}-{거래번호}\n{LINE_-}\n{상품리스트1}\n{LINE_-}\n{과세내역1}\n{LINE_-}\n{합계내역1}\n{결제내역1}\n{LINE_-}\n{스마트오더_완료영수증}\n{배달정보1}\n{CENTER}{캐셔정보1}\n\n{바코드1}\n\n{NADD}{하단메시지}\n{NADD}{무료주차안내}\n\n교환 및 환불은 영수증과 원거래          \n결제 수단 지참 후 14일 이내에           \n가능합니다. 단, 환불은 구입하신         \n매장에서만 가능합니다.  \n\n{로고이미지}\n{CUT}  ',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-20 11:25:31',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-20 11:25:31',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0002',
        SHOP_ID: '0003626',
        PRINTOUT_FLG_CD: '02',
        PRINTOUT_FORM:
          '{CENTER}{로고이미지}\n{CENTER}{FONT4}주문내역서\n{LINE_-}\n{FONT4}{CENTER}[주문번호 : {주문번호}]\n{LINE_-}\n[주문시간 : {판매일자} {판매시간}]\n{LINE_-}\n{상품리스트2-5}\n{LINE_-}\n{FONT3}{합계내역1}\n{LINE_-}\n판매자:{캐셔번호}({캐셔명})\n\n{CUT}',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-20 11:25:31',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-20 11:25:31',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0002',
        SHOP_ID: '0003626',
        PRINTOUT_FLG_CD: '03',
        PRINTOUT_FORM:
          '{CENTER}{FONT4}{타이틀1}\n{LINE_-}\n{CENTER}{FONT4}[주문번호 : {주문번호}]\n{LINE_-}\n{FONT3}{주방상품리스트1}\n{LINE_-}\n{FONT1}[주문시간 : {현재시간}]\n\n{CUT}\n',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-20 11:25:31',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-20 11:25:31',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0002',
        SHOP_ID: '0003626',
        PRINTOUT_FLG_CD: '04',
        PRINTOUT_FORM: '',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-20 11:25:31',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-20 11:25:31',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0002',
        SHOP_ID: '0003626',
        PRINTOUT_FLG_CD: '05',
        PRINTOUT_FORM:
          '{CENTER}{FONT4}교환권\n{LINE_-}\n{FONT4}{CENTER}[주문 번호 : {교환권번호}]\n{LINE_-}\n{FONT3}{교환권상품리스트1}\n{FONT1}\n{LINE_-}\n[주문시간 : {현재시간}]\n\n{CUT}',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-20 11:25:31',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-20 11:25:31',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0002',
        SHOP_ID: '0003626',
        PRINTOUT_FLG_CD: '06',
        PRINTOUT_FORM:
          '{NADD}{CENTER}{재발행1}\n\n점  포  명:{매장명}\n대  표  자:{매장대표자명}\n사업자번호:{매장사업자번호}\n전 화 번호:{매장전화번호}\n{주소1}\n{주소2}\n\n{판매일자} {판매시간}\n거래번호:{POS번호}-{거래번호}\n{FONT2}{CENTER}[ 준비금 ]\n{준비금}\n{NADD}{CENTER}{재발행2}\n{CENTER}{캐셔정보1}\n\n{바코드2}\n\n{바코드1}\n\n{CUT}',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-20 11:25:31',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-20 11:25:31',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0002',
        SHOP_ID: '0003626',
        PRINTOUT_FLG_CD: '07',
        PRINTOUT_FORM:
          '{NADD}{CENTER}{재발행1}\n\n점  포  명:{매장명}\n대  표  자:{매장대표자명}\n사업자번호:{매장사업자번호}\n전 화 번호:{매장전화번호}\n{주소1}\n{주소2}\n\n{판매일자} {판매시간}\n거래번호:{POS번호}-{거래번호}\n{FONT2}{CENTER}[ 시재출금 ]\n{시재출금}\n{NADD}{CENTER}{재발행2}\n{CENTER}{캐셔정보1}\n\n{바코드2}\n\n{바코드1}\n\n{CUT}',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-20 11:25:31',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-20 11:25:31',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0002',
        SHOP_ID: '0003626',
        PRINTOUT_FLG_CD: '08',
        PRINTOUT_FORM:
          '{NADD}{상단메시지}\n\n점  포  명:{매장명}\n대  표  자:{매장대표자명}\n사업자번호:{매장사업자번호}\n전 화 번호:{매장전화번호}\n{주소1}\n{주소2}\n{판매일자} {판매시간}\n거래번호:{POS번호}-{거래번호}\n            == 정산 영수증 ==\n          영업일자 : {판매일자}\n{정산_항목명}\n{정산_매출합계}\n{정산_결제수단별}\n{정산_현금}\n{정산_신용_현금IC}\n{정산_계약금}\n{정산_배달}\n{정산_고객수}\n\n{캐셔정보1}\n\n{바코드1}\n\n{NADD}{하단메시지}\n{NADD}{무료주차안내}\n\n교환 및 환불은 영수증과 원거래          \n결제 수단 지참 후 14일 이내에           \n가능합니다. 단, 환불은 구입하신         \n매장에서만 가능합니다.  \n\n{로고이미지}\n\n{CUT}  ',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-20 11:25:31',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-20 11:25:31',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0002',
        SHOP_ID: '0003626',
        PRINTOUT_FLG_CD: '09',
        PRINTOUT_FORM:
          '{CENTER}{FONT3}{MINUSSHADOW}[{SMT채널사명}]주문{취소구분} 전표[고객용]\n{FONT3}{CENTER}[{발행구분}]\n{SMT주문구분}\n{FONT3}{CENTER}▶ {SMT결제구분} ◀\n[주문채널] : {SMT채널사명}-{SMT채널주문번호}\n{SMT접수번호1}\n[POS] : {POS번호}-{주문번호} [{SMT제공사명}] : {SMT제공주문번호}\n[{SMT주문구분} 예정시간] : {SMT예정시간}분\n[주문일시] : {SMT주문일시}\n{SHADOW}{SMT예약일시1}\n{LINE_=}\n{FONT3}{SMT주소정보1}\n{FONT3}[연락처] : {SMT전화번호}\n{FONT3}{SMT요청사항1}\n{LINE_=}\n{FONT1}{상품리스트1-2}\n{LINE_-}\n{FONT1}{SMT합계내역1}\n{LINE_-}\n{FONT1}{SMT결제내역1}\n{LINE_-}\n▶상세 내역은 배달앱에서 확인하세요.◀\n[원산지] \n배달주문상품->쌀[국내산],돼지고기[외국산\n(미국,스페인,캐나다 등), 국내산혼합],돼\n지고기[미국산,국내산],달고기[미국산],소\n고기[호주산],배추김치(배추,고추가루)[중\n국산],배추김치(배추)[중국산],배추김치(고\n춧가루)[중국산]\n{LINE_=}\n[매장명]{매장명}\n[발행일시]{현재시간}\n\n{CUT}',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-20 11:25:31',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-20 11:25:31',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0002',
        SHOP_ID: '0003626',
        PRINTOUT_FLG_CD: '10',
        PRINTOUT_FORM:
          '{CENTER}{FONT3}{MINUSSHADOW}{취소구분}주방주문서[{발행구분}]\n{SMT주문구분}\n[주문채널] : {SMT채널사명}-{SMT채널주문번호}\n{SMT접수번호1}\n[POS] : {POS번호}-{주문번호} [{SMT제공사명}] : {SMT제공주문번호}\n[{SMT주문구분} 예정시간] : {SMT예정시간}분\n[주문일시] : {SMT주문일시}\n{SHADOW}{SMT예약일시1}\n{LINE_=}\n{FONT3}{주방상품리스트5}\n{LINE_-}\n{FONT3}{SMT요청사항2}\n{LINE_-}\n{LINE_=}\n[POS]{POS번호} \n[발행일시]{현재시간}\n\n{CUT}',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-20 11:25:31',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-20 11:25:31',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0002',
        SHOP_ID: '0003626',
        PRINTOUT_FLG_CD: '11',
        PRINTOUT_FORM:
          '{CENTER}{FONT3}{MINUSSHADOW}[스마트오더]\n[주문채널] : {SMT채널사명}-{SMT채널주문번호}\n{SMT접수번호1}\n[POS] : {POS번호}-{주문번호} [{SMT제공사명}] : {SMT제공주문번호}\n[{SMT주문구분} 예정시간] : {SMT예정시간}분\n[주문일시] : {SMT주문일시}\n{SHADOW}{SMT예약일시1}\n{LINE_-}\n{FONT3}{SMT요청사항1}\n{LINE_-}\n{FONT1}{SMT결제내역1}',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-20 11:25:31',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-20 11:25:31',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0002',
        SHOP_ID: '0003626',
        PRINTOUT_FLG_CD: '12',
        PRINTOUT_FORM:
          '{NADD}{CENTER}{재발행1}\n\n점  포  명:{매장명}\n대  표  자:{매장대표자명}\n사업자번호:{매장사업자번호}\n전 화 번호:{매장전화번호}\n{주소1}\n{주소2}\n\n{판매일자} {판매시간}\n거래번호:{POS번호}-{거래번호}\n{FONT2}{CENTER}[ 개점 ]\n{CENTER}{캐셔정보1}\n\n{바코드1}\n\n{CUT}',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-20 11:25:31',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-20 11:25:31',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
    ],
    TB_MST_SLDOUT: [
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0002',
        SHOP_ID: '0003626',
        ITEM_CD: '00000092',
        SLDOUT_YN: 'N',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-20 11:25:36',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-20 11:25:36',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
    ],
    TB_MST_KIOSK_CLAS: [
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0002',
        SHOP_ID: '0003626',
        KOS_CLASS_CD: '햄버거',
        KOS_ORDER: 1,
        KOS_MENU_NM_KO: '햄버거',
        KOS_MENU_NM_EN: 'Burger',
        KOS_MENU_NM_JP: 'バーガー',
        KOS_MENU_NM_CN: '',
        KOS_MENU_NM_TW: '',
        KOS_USE_YN: 'Y',
        SMARTORDER_YN: 'N',
        KOS_MENU_IMG_FILE_ID: '',
        KOS_MENU_IMG_FILE_URL: '',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-20 11:25:36',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-20 11:25:36',
        UPDTER_ID: '',
        UPDT_IP: '',
        KOS_MENU_NM: '햄버거',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0002',
        SHOP_ID: '0003626',
        KOS_CLASS_CD: '사이드 메뉴',
        KOS_ORDER: 2,
        KOS_MENU_NM_KO: '사이드 메뉴',
        KOS_MENU_NM_EN: 'Side Menu',
        KOS_MENU_NM_JP: 'サイドメニュー',
        KOS_MENU_NM_CN: '',
        KOS_MENU_NM_TW: '',
        KOS_USE_YN: 'Y',
        SMARTORDER_YN: 'N',
        KOS_MENU_IMG_FILE_ID: '',
        KOS_MENU_IMG_FILE_URL: '',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-20 11:25:36',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-20 11:25:36',
        UPDTER_ID: '',
        UPDT_IP: '',
        KOS_MENU_NM: '사이드 메뉴',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0002',
        SHOP_ID: '0003626',
        KOS_CLASS_CD: '음료수',
        KOS_ORDER: 3,
        KOS_MENU_NM_KO: '음료수',
        KOS_MENU_NM_EN: 'Beverage',
        KOS_MENU_NM_JP: '飲料水',
        KOS_MENU_NM_CN: '',
        KOS_MENU_NM_TW: '',
        KOS_USE_YN: 'Y',
        SMARTORDER_YN: 'N',
        KOS_MENU_IMG_FILE_ID: '',
        KOS_MENU_IMG_FILE_URL: '',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-20 11:25:36',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-20 11:25:36',
        UPDTER_ID: '',
        UPDT_IP: '',
        KOS_MENU_NM: '사이드 메뉴',
      },
    ],
    TB_MST_TNANT_BIZTIME: [
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0002',
        SHOP_ID: '0003626',
        DAY: '1',
        OPEN_TIME: '0900',
        CLOSE_TIME: '2330',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-20 11:26:23',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-20 11:26:23',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0002',
        SHOP_ID: '0003626',
        DAY: '2',
        OPEN_TIME: '0000',
        CLOSE_TIME: '2359',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-20 11:26:23',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-20 11:26:23',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0002',
        SHOP_ID: '0003626',
        DAY: '3',
        OPEN_TIME: '0000',
        CLOSE_TIME: '2359',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-20 11:26:23',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-20 11:26:23',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0002',
        SHOP_ID: '0003626',
        DAY: '4',
        OPEN_TIME: '1120',
        CLOSE_TIME: '0200',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-20 11:26:23',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-20 11:26:23',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0002',
        SHOP_ID: '0003626',
        DAY: '5',
        OPEN_TIME: '1000',
        CLOSE_TIME: '2330',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-20 11:26:23',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-20 11:26:23',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0002',
        SHOP_ID: '0003626',
        DAY: '6',
        OPEN_TIME: '0900',
        CLOSE_TIME: '2330',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-20 11:26:23',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-20 11:26:23',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0002',
        SHOP_ID: '0003626',
        DAY: '7',
        OPEN_TIME: '0900',
        CLOSE_TIME: '2330',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-20 11:26:23',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-20 11:26:23',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
    ],
    POS_DEVICE_INFO: [],
    TB_MST_CUST_DISP: [
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0009',
        SHOP_ID: '0003809',
        GRP_CD: '000001',
        DISP_AREA: '02',
        SEQ_NO: 1,
        DISP_KIND_CD: 'I',
        DISP_TEXT_KO: '안녕하세요^주문 방법을^선택해주세요.',
        DISP_TEXT_EN: 'Welcome^Touch To Start',
        DISP_TEXT_JP: 'いらっしゃいませ^ご注文を選択してください。',
        DISP_TEXT_CN: '',
        DISP_TEXT_TW: '',
        FILE_ID: '2122375276',
        FILE_URL: require('../../../assets/images/food/idle/food_idle_banner.png'),
        MOV_TN_FILE_ID: '',
        MOV_TN_FILE_URL: '',
        DISP_TIME: 60,
        FROM_DATE: '20230801',
        END_DATE: '99990831',
        FROM_TIME: '0000',
        END_TIME: '2359',
        DISP_ORDER: 1,
        FONT_FLG_CD: '1',
        FONT_SIZE_CD: '10',
        BOLD_YN: 'Y',
        USE_YN: 'Y',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-19 11:08:33',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-19 11:08:33',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0009',
        SHOP_ID: '0003809',
        GRP_CD: '000001',
        DISP_AREA: '03',
        SEQ_NO: 1,
        DISP_KIND_CD: 'I',
        DISP_TEXT_KO: '안녕하세요^주문 방법을^선택해주세요.',
        DISP_TEXT_EN: 'Welcome^Touch To Start',
        DISP_TEXT_JP: 'いらっしゃいませ^ご注文を選択してください。',
        DISP_TEXT_CN: '',
        DISP_TEXT_TW: '',
        FILE_ID: '2122375276',
        FILE_URL: require('../../../assets/images/food/idle/food_idle_banner.png'),
        MOV_TN_FILE_ID: '',
        MOV_TN_FILE_URL: '',
        DISP_TIME: 60,
        FROM_DATE: '20230801',
        END_DATE: '99990831',
        FROM_TIME: '0000',
        END_TIME: '2359',
        DISP_ORDER: 1,
        FONT_FLG_CD: '1',
        FONT_SIZE_CD: '10',
        BOLD_YN: 'Y',
        USE_YN: 'Y',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-19 11:08:33',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-19 11:08:33',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0009',
        SHOP_ID: '0003809',
        GRP_CD: '000001',
        DISP_AREA: '04',
        SEQ_NO: 1,
        DISP_KIND_CD: 'T',
        DISP_TEXT_KO: '안녕하세요^주문 방법을 선택해주세요.',
        DISP_TEXT_EN: 'Welcome^Touch To Start',
        DISP_TEXT_JP: 'いらっしゃいませ^ご注文を選択してください。',
        DISP_TEXT_CN: '',
        DISP_TEXT_TW: '',
        FILE_ID: '',
        FILE_URL: '',
        MOV_TN_FILE_ID: '',
        MOV_TN_FILE_URL: '',
        DISP_TIME: 60,
        FROM_DATE: '20230801',
        END_DATE: '99990831',
        FROM_TIME: '0000',
        END_TIME: '2359',
        DISP_ORDER: 1,
        FONT_FLG_CD: '1',
        FONT_SIZE_CD: '10',
        BOLD_YN: 'Y',
        USE_YN: 'Y',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-19 11:08:33',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-19 11:08:33',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0009',
        SHOP_ID: '0003809',
        GRP_CD: '000001',
        DISP_AREA: '05',
        SEQ_NO: 2,
        DISP_KIND_CD: 'I',
        DISP_TEXT_KO: '',
        DISP_TEXT_EN: '',
        DISP_TEXT_JP: '',
        DISP_TEXT_CN: '',
        DISP_TEXT_TW: '',
        FILE_ID: '2122375276',
        FILE_URL: require('../../../assets/images/food/banner/food_order_banner.png'),
        MOV_TN_FILE_ID: '',
        MOV_TN_FILE_URL: '',
        DISP_TIME: 5,
        FROM_DATE: '20230801',
        END_DATE: '99990803',
        FROM_TIME: '0000',
        END_TIME: '2359',
        DISP_ORDER: 2,
        FONT_FLG_CD: '',
        FONT_SIZE_CD: '',
        BOLD_YN: 'N',
        USE_YN: 'Y',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-19 11:08:33',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-19 11:08:33',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
    ],
  },
  message: '',
};
